import * as React from 'react';

import pngBackgroundBase64 from '../assets/png-background.png';
import slotPlaceholderBase64 from '../assets/slot-placeholder.png';
import { SlotScrapInfo } from '../../../common/models/single-template-model';
import { useDomRect } from '../../../common/hooks/use-dom-rect';
type Props = {
  templateSize: { width: number; height: number };
  slotScrapInfo: SlotScrapInfo;
};

export function SlotScrapCard({ templateSize, slotScrapInfo }: Props) {
  const imageId = React.useMemo(() => Math.random().toString(36).substring(2, 15), []);
  const [wrapperDom, setWrapperDom] = React.useState<HTMLDivElement | null>(null);
  const wrapperRect = useDomRect(wrapperDom);

  const domCollageRatio = wrapperRect ? wrapperRect.width / templateSize.width : 1;

  const scrapWidth = slotScrapInfo.size.width;
  const scrapHeight = slotScrapInfo.size.height;

  const scrapScaleWidth = slotScrapInfo.scale.width;
  const scrapScaleHeight = slotScrapInfo.scale.height;

  const scrapCenter = slotScrapInfo.center;
  const scrapRotateInDegrees = (slotScrapInfo.angle * 180) / Math.PI;

  const slotPath = slotScrapInfo.slot.path;
  const slotSize = slotScrapInfo.slot.size;
  const slotCenter = slotScrapInfo.slot.center;

  const decoOverlay = slotScrapInfo.decoOverlay;

  return (
    <div
      ref={setWrapperDom}
      style={{
        position: 'relative',
        background: `url("${pngBackgroundBase64}")`,
        backgroundSize: '100% 100%',
        width: '100%',
        aspectRatio: `${templateSize.width}/${templateSize.height}`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: templateSize.width,
          height: templateSize.height,
          transformOrigin: 'left top',
          transform: `scale(${domCollageRatio}, ${domCollageRatio})`,
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: scrapCenter.y,
            left: scrapCenter.x,
            width: scrapWidth,
            height: scrapHeight,
            transformOrigin: 'center',
            transform: `translate(-50%, -50%) rotate(${scrapRotateInDegrees}deg) scale(${scrapScaleWidth}, ${scrapScaleHeight})`,
          }}
        >
          {decoOverlay && (
            <img
              width={decoOverlay.size.width}
              height={decoOverlay.size.height}
              style={{
                position: 'absolute',
                top: decoOverlay.center.y,
                left: decoOverlay.center.x,
                transformOrigin: 'center',
                transform: `translate(-50%, -50%)`,
                zIndex: 2,
              }}
              src={decoOverlay.imageUrl}
            />
          )}
          <svg
            width={slotSize.width}
            height={slotSize.height}
            style={{
              position: 'absolute',
              top: slotCenter.y,
              left: slotCenter.x,
              transformOrigin: 'center',
              transform: `translate(-50%, -50%)`,
              zIndex: 1,
            }}
          >
            <defs>
              <pattern id={imageId} patternUnits="userSpaceOnUse" width={171} height={234}>
                <image href={slotPlaceholderBase64} x={0} y={0} width={171} height={234} />
              </pattern>
            </defs>
            <path
              d={
                slotPath ??
                `M 0 0 L ${slotSize.width} 0 L ${slotSize.width} ${slotSize.height} L 0 ${slotSize.height} Z`
              }
              fill={`url(#${imageId})`}
            />
          </svg>
        </div>
      </div>
    </div>
  );
}
